<template>
<div class="chapter">
<div class="inner_page">
<p class="TSR_Teaser_text">In fond memory of Kenneth Owler Smith – mentor and dear friend</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1bfc6107